import { render, staticRenderFns } from "./mrp-yxjd-edit.vue?vue&type=template&id=0a2cd49a&scoped=true"
import script from "./mrp-yxjd-edit.vue?vue&type=script&lang=js"
export * from "./mrp-yxjd-edit.vue?vue&type=script&lang=js"
import style0 from "./mrp-yxjd-edit.vue?vue&type=style&index=0&id=0a2cd49a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2cd49a",
  null
  
)

export default component.exports